/**
 * Compares two state values via JSON serialization.
 * Used by reducers that guard against unnecessary updates.
 */
export const shouldUpdateState = (currentState, newState) =>
    JSON.stringify(currentState) !== JSON.stringify(newState);

/**
 * Factory for table filter update reducers.
 * Replaces 14 identical reducers that all do:
 *   state[key] = { ...state[key], ...action.payload }
 */
export const createFilterUpdater = (stateKey) => (state, action) => {
    state[stateKey] = { ...state[stateKey], ...action.payload };
};
